import React from "react";
import { RunsTab, sampleAgent } from "./index";
import { AgentLayout } from "./AgentLayout";

export const RunsPage: React.FC = () => {
  // In a real app, you would fetch the agent data based on agentId
  const agent = sampleAgent;

  return (
    <AgentLayout activeTab="runs">
      <RunsTab agent={agent} />
    </AgentLayout>
  );
};
